import React from 'react';
import { Popup } from 'devextreme-react/popup';
import style from './popupmvp.module.scss';

const PopupMVP = ({
  children,
  className,
  closeOnOutsideClick = true,
  dragEnabled = true,
  fullScreen = false,
  height = null,
  onHiding,
  position = { my: 'center', at: 'center', of: window },
  // resizeEnabled = true,
  resizeEnabled = false,
  showTitle = true,
  title,
  visible,
  width
}) => (
  <Popup className={`${style.popup}  ${className}`}
         dragEnabled={dragEnabled}
         resizeEnabled={resizeEnabled}
         position={position}
         closeOnOutsideClick={closeOnOutsideClick}
         showTitle={showTitle}
         // width={width || 680}
         // minWidth={width || 680}
         width={'auto' && (width || 680)}
         height={'auto' && height}
         title={title}
         onHiding={onHiding}
         visible={visible}
         fullScreen={fullScreen}
  >
    {children}
  </Popup>
);

export default PopupMVP;
